import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('Iframe').create(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'stretch',
    height: '100%',
    width: '100%',
  },
  header: {
    width: '100%',
    height: '66px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0px 12px',
  },

  iframe: {
    width: '100%',
    height: '100%',
  },

  textField: {
    display: 'flex',
    flexDirection: 'row',
    height: '48px',
    width: '100%',
    backgroundColor: 'white',
    borderRadius: '12px',
    padding: '0 16px',
  },
}))
